export const textCodes = {

    contactUs: {
        code: "${merchantId}_tmpl_text_4",
        text: "လိုအပ်သော ဆေးဝါး အမျိုးမျိုးကို တစ်နေရာတည်းတွင် အမြန်ဆုံးနှင့် အလျှင်မြန်ဆုံး အလွယ်တကူ၀ယ်ယူနိုင်သော VCARE Pharmacy"
    },

    hapiness: {
        code: "${merchantId}_tmpl_text_5",
        text: "Your Health is Our Happiness."
    },

    fbLink: {
        code: "${merchantId}_tmpl_text_17",
        text: "https://www.facebook.com/vcaremyanmar"
    },

    vbLink: {
        code: "${merchantId}_tmpl_text_18",
        text: "https://bit.ly/3J8P0LS"
    },

    tgLink: {
        code: "${merchantId}_tmpl_text_19",
        text: "https://t.me/+O_w4xIVle_llYzM1"
    },

    phone1: {
        code: "${merchantId}_tmpl_text_6",
        text: "Ph: 09-940 7777 13, 09-940 7777 14"
    },

    address1: {
        code: "${merchantId}_tmpl_text_7",
        text: "အမှတ် B3/A1၊ သမိုင်းလမ်းဆုံ (CNG ဓာတ်ငွေ့ဆိုင်ရှေ့)၊ Ford Car Showroom အနီး၊ မရမ်းကုန်းမြို့နယ်၊ ရန်ကုန်မြို့။"
    },

    phone2: {
        code: "${merchantId}_tmpl_text_8",
        text: "Ph: 09 940 7777 18"
    },

    address2: {
        code: "${merchantId}_tmpl_text_9",
        text: "အမှတ် 748/B၊ မြေညီထပ်၊ မဟာဗန္ဓုလလမ်း၊ (လမ်းမတော်မီးပွိုင့်၊ ရွှေစင်ဆိုင်ဘေး)၊ လမ်းမတော်မြို့နယ် ရန်ကုန်မြို့။"
    },

    phone3: {
        code: "${merchantId}_tmpl_text_10",
        text: "Ph: 09 940 7777 19"
    },

    address3: {
        code: "${merchantId}_tmpl_text_11",
        text: "အမှတ် ၁၉၊ ပထမထပ်၊ (၃)ရပ်ကွက်၊ ဘုရင့်နောင်လမ်းမကြီး၊ လှိုင်မြို့နယ်။ (အေးရိပ်မွန် (၅)လမ်းထိပ်၊ Buy More Mart အတွင်း)"
    },

    phone4: {
        code: "${merchantId}_tmpl_text_15",
        text: "Ph: 09 940 7777 16"
    },

    address4: {
        code: "${merchantId}_tmpl_text_16",
        text: "အမှတ် ၂၅၊ မြေညီထပ်၊ (၉)ရပ်ကွက်၊ ရေကျော်လမ်းမတန်း၊ ပုဇွန်တောင်မြို့နယ်၊ (ရေကျော်ဈေးရှေ့)။"
    },
}

export const titleCodes = {

    contactVcare: {
        code: "${merchantId}_tmpl_text_2",
        title: "VCare Pharmacy"
    },

    fbPage: {
        code: "${merchantId}_tmpl_text_7",
        title: "Facebook Page"
    },

    vbGroup: {
        code: "${merchantId}_tmpl_text_8",
        title: "Viber Group"
    },

    tgChannel: {
        code: "${merchantId}_tmpl_text_9",
        title: "Telegram Channel"
    },

    thamine: {
        code: "${merchantId}_tmpl_text_10",
        title: "သမိုင်းဆိုင်ခွဲ"
    },

    lanmadaw: {
        code: "${merchantId}_tmpl_text_11",
        title: "လမ်းမတော်ဆိုင်ခွဲ"
    },

    hlaing: {
        code: "${merchantId}_tmpl_text_12",
        title: "လှိုင်ဆိုင်ခွဲ"
    },

    pazuntaung: {
        code: "${merchantId}_tmpl_text_13",
        title: "ပုဇွန်တောင်ဆိုင်ခွဲ"
    },
}